module.exports = __webpack_public_path__ + "media/images/emblems/Zuchwil-blason-3eb53296344a69216026bf735dc27ff4.png";